import { render, staticRenderFns } from "./ProductItemsSummary.vue?vue&type=template&id=450abcc3&"
import script from "./ProductItemsSummary.vue?vue&type=script&lang=js&"
export * from "./ProductItemsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports